<template>
    <div class="c-app flex-row align-items-center">
        <CContainer>
            <CRow class="justify-content-center">
                <child />
            </CRow>
        </CContainer>
        <div class="container-version">
            <span
                class="text-center text-wrap"
                style="font-size: 0.9em; color: gray; width: 72%"
            >
                pre-v{{ version }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "BasicLayout",
    data() {
        return {
            version: process.env.VUE_APP_VERSION,
        };
    },
    mounted() {},
};
</script>
<style lang="scss" scoped>
.container-version {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 0.5rem;
}
</style>
